export const USER_TYPE = {
  GUEST: 'guest',
  USER: 'user',
  MANAGER: 'manager',
};
